<template>
    <div class="row align-items-md-stretch" v-if="flash.success">
        <div class="col-12">
            <div class="alert alert-success" role="alert">
                {{ flash.success }}
            </div>
        </div>
    </div>
    <div class="row align-items-md-stretch pb-5">
        <div class="col-md-6" v-if="cek_sekolah">
            <div class="h-100 p-5 bg-light border rounded-3">
                <h2>Pilih Sekolah</h2>
                <form @submit.prevent="submit">
                    <div class="input-group">
                        <select :class="{ 'form-select': true, 'is-invalid': errors.sekolah_id ? true : false }"
                            aria-label="Default select example" v-model="form.sekolah_id" aria-describedby="sekolah_id">
                            <option selected :value="null">== Pilih Sekolah ==</option>
                            <option v-for="s in sekolah" :key="s.sekolah_id" :value="s.sekolah_id">{{ s.nama }}</option>
                        </select>
                        <button class="btn btn-outline-secondary" type="submit">Simpan</button>
                        <div v-if="errors.sekolah_id" id="sekolah_id" class="invalid-feedback">{{ errors.sekolah_id }}
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div :class="{ 'col-md-6': cek_sekolah ? true : false, 'col-12': cek_sekolah ? false : true }">
            <div class="h-100 p-5 bg-light border rounded-3">
                <h2>Cari Data Peserta Didik</h2>
                <form @submit.prevent="submitSiswa">
                    <div class="input-group">
                        <input type="text" :class="{ 'form-control': true, 'is-invalid': errors.nik ? true : false }"
                            aria-describedby="nik" placeholder="Masukkan NIK" aria-label="Recipient's username"
                            v-model="form.nik">
                        <button class="btn btn-outline-secondary" type="submit" :disabled="isDisabled">
                            <template v-if="isDisabled">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                Loading...
                            </template>
                            <template v-else>
                                Cari...
                            </template>
                        </button>
                        <div v-if="errors.nik" id="nik" class="invalid-feedback">{{ errors.nik }}</div>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <div class="row align-items-md-stretch pb-5" v-if="flash.nik">
        <div class="col-md-5">
            <div class="h-100 p-5 bg-light border rounded-3">
                <h2>Hasil Pencarian</h2>
                <template v-if="flash.siswa">
                    <table class="table table-bordered">
                        <tr>
                            <td>Nama</td>
                            <td>{{ flash.siswa.nama }}</td>
                        </tr>
                        <tr>
                            <td>NIK</td>
                            <td>{{ flash.siswa.nik }}</td>
                        </tr>
                        <tr>
                            <td>NISN</td>
                            <td>{{ flash.siswa.nisn }}</td>
                        </tr>
                        <tr>
                            <td>Tempat, Tanggal Lahir</td>
                            <td>{{ flash.siswa.tempat_lahir }}, {{ flash.siswa.tanggal_lahir }}</td>
                        </tr>
                        <tr>
                            <td>Nama Ibu Kandung</td>
                            <td>{{ flash.siswa.nama_ibu_kandung }}</td>
                        </tr>
                    </table>
                </template>
                <template v-else>
                    <p>NIK tidak ditemukan!</p>
                </template>
            </div>
        </div>
        <div class="col-md-7">
            <div class="h-100 p-5 bg-light border rounded-3">
                <h2>Riwayat Pendidikan Siswa</h2>
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <td class="text-center">Nama Sekolah</td>
                            <td class="text-center">NPSN</td>
                            <td class="text-center">Jenis Keluar</td>
                            <td class="text-center">Tanggal Keluar</td>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-if="flash.siswa">
                            <tr v-for="(reg, index) in flash.siswa.registrasi_pd" :key="reg.registrasi_id">
                                <td>{{ reg.sekolah.nama }}</td>
                                <td class="text-center">{{ reg.sekolah.npsn }}</td>
                                <td class="text-center">{{ jenis_keluar(reg.jenis_keluar_id) }}</td>
                                <td class="text-center">{{ reg.tanggal_keluar }}</td>
                            </tr>
                        </template>
                        <template v-else>
                            <tr>
                                <td class="text-center" colspan="4">Tidak ada data untuk ditampilkan</td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="row pb-5" v-if="flash.siswa && cek_sekolah">
        <div class="col-12">
            <h2>Daftarkan Siswa</h2>
            <form @submit.prevent="registrasi">
                <div class="h-100 p-5 bg-light border rounded-3">
                    <div class="row g-5">
                        <div class="col-md-5">
                            <label for="jenis_pendaftaran_id" class="form-label">Jenis Pendaftaran</label>
                            <select id="jenis_pendaftaran_id" v-model="form.jenis_pendaftaran_id"
                                :class="{ 'form-select': true, 'is-invalid': errors.jenis_pendaftaran_id ? true : false }"
                                aria-describedby="nik" required>
                                <option value="">== Pilih ==</option>
                                <option v-for="pendaftaran in jenis_pendaftaran" :key="pendaftaran.jenis_pendaftaran_id"
                                    :value="pendaftaran.jenis_pendaftaran_id">{{ pendaftaran.nama }}</option>
                            </select>
                            <div v-if="errors.jenis_pendaftaran_id" id="jenis_pendaftaran_id" class="invalid-feedback">
                                {{
                                    errors.jenis_pendaftaran_id }}</div>
                        </div>

                        <div class="col-md-4">
                            <label for="tanggal_masuk_sekolah" class="form-label">Tanggal Masuk Sekolah</label>
                            <vue-date-picker id="tanggal_masuk_sekolah" v-model="form.tanggal_masuk_sekolah" locale="id"
                                :format="formatDate" :action-row="{ showSelect: false, showCancel: false }" auto-apply
                                :class="{ 'is-invalid': errors.jenis_pendaftaran_id ? true : false }"
                                aria-describedby="tanggal_masuk_sekolah" required></vue-date-picker>
                            <div v-if="errors.tanggal_masuk_sekolah" id="tanggal_masuk_sekolah"
                                class="invalid-feedback">{{
                                    errors.tanggal_masuk_sekolah }}</div>
                        </div>

                        <div class="col-md-3">
                            <label for="nipd" class="form-label">Nomor Induk</label>
                            <input type="text" id="nipd" v-model="form.nipd" placeholder=""
                                :class="{ 'form-control': true, 'is-invalid': errors.nipd ? true : false }"
                                aria-describedby="nipd">
                            <div v-if="errors.nipd" id="nipd" class="invalid-feedback">{{ errors.nipd }}</div>
                        </div>
                        <div class="col-12">
                            <label for="rombongan_belajar_id" class="form-label">Rombongan Belajar</label>
                            <template v-if="flash.rombongan_belajar">
                                <template v-for="rombel in flash.rombongan_belajar">
                                    <div class="form-check">
                                        <input class="form-check-input" type="radio" name="rombongan_belajar_id"
                                            :id="rombel.rombongan_belajar_id" :value="rombel.rombongan_belajar_id"
                                            v-model="form.rombongan_belajar_id">
                                        <label class="form-check-label" :for="rombel.rombongan_belajar_id">
                                            {{ rombel.nama }}
                                        </label>
                                    </div>
                                </template>
                            </template>
                        </div>
                        <div class="col-12">
                            <button type="submit" class="btn btn-primary">Simpan</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>
<script>
import Main from "@/Layouts/Main.vue";
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
export default {
    layout: Main,
    props: {
        auth: Object,
        errors: Object,
        sekolah: Array,
        user: Object,
        siswa: Object,
        flash: Object,
        jenis_pendaftaran: Array,
    },
    components: { VueDatePicker },
    data() {
        return {
            form: this.$inertia.form({
                sekolah_id: null,
                nik: null,
                jenis_pendaftaran_id: '',
                peserta_didik: null,
                tanggal_masuk_sekolah: new Date,
                nipd: null,
                rombongan_belajar_id: null,
            }),
            errors: {
                sekolah_id: null,
                nik: null,
                jenis_pendaftaran_id: null,
                tanggal_masuk_sekolah: null,
                nipd: null,
                rombongan_belajar_id: null,
            },
            options: this.sekolah,
            isDisabled: false,
            cek_sekolah: this.sekolah.length ? true : false,
        }
    },
    mounted() {
        this.$store.dispatch("setAuth", this.auth);
    },
    created() {
        this.form.sekolah_id = this.auth.user.sekolah_id
    },
    methods: {
        formatDate() {
            const date = this.form.tanggal_masuk_sekolah
            const day = ("0" + date.getDate()).slice(-2);
            const month = ("0" + (date.getMonth() + 1)).slice(-2);
            const year = date.getFullYear();

            return `${day}/${month}/${year}`;
        },
        submit() {
            this.form['post'](this.route("dashboard.store"), {
                onError: (errors) => {

                    if (Object.entries(errors).length !== 0) {
                        var toast = {
                            bg: "bg-danger",
                        };

                        if (errors.hasOwnProperty("sekolah_id")) {
                            toast.message = errors.sekolah_id;
                            this.errors.sekolah_id = errors.sekolah_id;
                        }
                    }
                },
                onSuccess: () => {
                    this.errors.sekolah_id = null
                }
            });
        },
        submitSiswa() {
            this.isDisabled = true
            this.form['post'](this.route("dashboard.siswa"), {
                onError: (errors) => {
                    this.isDisabled = false
                    console.log(errors);
                    if (Object.entries(errors).length !== 0) {
                        var toast = {
                            bg: "bg-danger",
                        };

                        if (errors.hasOwnProperty("nik")) {
                            toast.message = errors.nik;
                            this.errors.nik = errors.nik;
                        }
                    }
                },
                onSuccess: (result) => {
                    this.form.peserta_didik = result.props.flash.siswa
                    this.isDisabled = false
                    //this.form.nik = null
                    this.errors.nik = null
                }
            });
        },
        registrasi() {
            this.form['post'](this.route("dashboard.daftar"), {
                onError: (errors) => {
                    this.isDisabled = false
                    if (Object.entries(errors).length !== 0) {
                        if (errors.hasOwnProperty("jenis_pendaftaran_id")) {
                            this.errors.jenis_pendaftaran_id = errors.jenis_pendaftaran_id;
                            this.errors.tanggal_masuk_sekolah = errors.tanggal_masuk_sekolah;
                        }
                    }
                },
                onSuccess: () => {
                    this.form.peserta_didik = null
                    this.errors.jenis_pendaftaran_id = null
                    this.errors.tanggal_masuk_sekolah = null
                }
            });
        },
        jenis_keluar(id) {
            var data = {
                "1": "Lulus",
                "2": "Mutasi",
                "3": "Dikeluarkan",
                "4": "Mengundurkan diri",
                "5": "Putus Sekolah",
                "6": "Wafat",
                "7": "Hilang",
            }
            if (id) {
                return data[id];
            }
        }
    },
};
</script>
